import { Space, Form, Row, Button, Col } from "antd";
import { observer } from "mobx-react-lite";

import { useGlobalStore } from "@/stores";

import ErrorsFormatter from "../../../_common_/errors-formatter";
import { FormItem, FormSwitch } from "../../../_common_/form-helpers";
import { FormSpinner } from "../../../_common_/form-spinner";

import { AgentOtherSettingsState } from "./agent-other-settings.state";

interface Props {
  state: AgentOtherSettingsState;
}

export const AgentOtherSettingsView = observer(({ state }: Props) => {
  const { intl, form, agentQuery, submitQuery } = state;
  const { userStore } = useGlobalStore();

  if (agentQuery.isIdle || agentQuery.isPending) {
    return <FormSpinner />;
  }

  if (agentQuery.isRejected) {
    return <ErrorsFormatter queries={[agentQuery]} />;
  }

  const agent = agentQuery.data;

  return (
    <Space direction="vertical">
      <ErrorsFormatter queries={[submitQuery]} />
      <Form
        labelCol={{ span: 8 }}
        labelAlign="left"
        wrapperCol={{ span: 16 }}
        layout="horizontal"
        onFinish={form.handleSubmit(submitQuery.submit)}
      >
        {agent.isCustomDocumentsSet !== undefined && (
          <FormItem
            form={form}
            path="isCustomDocumentsSet"
            label={intl.formatMessage({
              defaultMessage: "Custom documents set",
            })}
          >
            <FormSwitch
              form={form}
              path="isCustomDocumentsSet"
              disabled={!["Admin", "Manager"].includes(userStore.user.role)}
            />
          </FormItem>
        )}
        <FormItem
          form={form}
          path="cashierSettings.isShortPlayerCreation"
          label={intl.formatMessage({
            defaultMessage: "Player creation: short form",
          })}
          isColonShown={false}
        >
          <FormSwitch
            form={form}
            path="cashierSettings.isShortPlayerCreation"
          />
        </FormItem>
        <Row justify="end" gutter={12}>
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitQuery.isPending}
            >
              {intl.formatMessage({ defaultMessage: "Save" })}
            </Button>
          </Col>
        </Row>
      </Form>
    </Space>
  );
});
